export default {
  LOGIN: 'LOGIN',
  SIGNUP: 'SIGNUP',
  SETTINGS: 'SETTINGS',
};
